"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var SyncOverlay_1 = require("@twii/core-ui-fabric/lib/component/SyncOverlay");
var Listing_styles_1 = require("./Listing.styles");
var Listing_classNames_1 = require("./Listing.classNames");
var Pivot_1 = require("office-ui-fabric-react/lib/Pivot");
var Rating_1 = require("office-ui-fabric-react/lib/Rating");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var ListingSupplier_1 = require("./ListingSupplier");
var ListingReviewList_1 = require("./ListingReviewList");
var ListingReviewHelper_1 = require("../model/ListingReviewHelper");
var ListingActivityList_1 = require("./ListingActivityList");
var ListingActivityHelper_1 = require("../model/ListingActivityHelper");
var ListingBookmarkListStore_1 = require("../model/ListingBookmarkListStore");
var Dialog_1 = require("office-ui-fabric-react/lib/Dialog");
var ListingLinks_1 = require("./ListingLinks");
var ListingBookmarkButton_1 = require("./ListingBookmarkButton");
var ListingActions_1 = require("./ListingActions");
var Image_1 = require("office-ui-fabric-react/lib/Image");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var utilities_1 = require("@uifabric/utilities");
var ListingReviews = /** @class */ (function (_super) {
    __extends(ListingReviews, _super);
    function ListingReviews() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingReviews.prototype.render = function () {
        return React.createElement(ListingReviewList_1.ListingReviewListContainer, { reviewList: ListingReviewHelper_1.getReviews(this.props.listing) });
    };
    return ListingReviews;
}(React.Component));
var ListingActivity = /** @class */ (function (_super) {
    __extends(ListingActivity, _super);
    function ListingActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingActivity.prototype.render = function () {
        return React.createElement(ListingActivityList_1.ListingActivityListContainer, { activityList: ListingActivityHelper_1.getActivity(this.props.listing) });
    };
    return ListingActivity;
}(React.Component));
var Listing = /** @class */ (function (_super) {
    __extends(Listing, _super);
    function Listing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Listing.prototype._renderBanner = function () {
        var listingBannerIcon = this.props.listing.banner_icon;
        var banner;
        var bannerIsIcon = false;
        if (listingBannerIcon && listingBannerIcon.url) {
            banner = React.createElement(Image_1.Image, { width: 220, height: 137, src: listingBannerIcon.url, alt: this.props.listing.title });
        }
        else {
            bannerIsIcon = true;
            banner = React.createElement(Icon_1.Icon, { iconName: "Puzzle", className: "banner-icon", title: this.props.listing.title });
        }
        return (React.createElement("div", { className: utilities_1.css(this._classNames.banner, { "is-icon": bannerIsIcon }) }, banner));
    };
    Listing.prototype._renderActions = function () {
        return (React.createElement("div", { className: this._classNames.actions },
            React.createElement(ListingBookmarkButton_1.ListingBookmarkButton, { bookmarkList: ListingBookmarkListStore_1.ListingBookmarkListStore, listingId: this.props.listing.id }),
            React.createElement(ListingActions_1.ListingLoadAction, { onLoad: this.props.onLoad, listing: this.props.listing }),
            React.createElement(ListingActions_1.ListingOpenAction, { onOpen: this.props.onOpen, listing: this.props.listing })));
    };
    Listing.prototype._renderRating = function () {
        var content;
        var reviewCount;
        if (this.props.listing.avg_rate !== undefined && this.props.listing.avg_rate > 0) {
            content = React.createElement(Rating_1.Rating, { min: 1, max: 5, rating: this.props.listing.avg_rate, readOnly: true, ariaLabelFormat: "Rated {0} out of {1}" });
            reviewCount = React.createElement("div", { className: this._classNames.reviewCount },
                "(",
                this.props.listing.total_reviews,
                ")");
        }
        else {
            content = React.createElement(Rating_1.Rating, { title: "No Reviews Available", min: 1, max: 5, rating: 5, readOnly: true, disabled: true, ariaLabelFormat: "No reviews available" });
        }
        return (React.createElement("div", { className: this._classNames.rating },
            content,
            reviewCount));
    };
    Listing.prototype._renderVersion = function () {
        if (this.props.listing.version_name) {
            return (React.createElement("div", { className: this._classNames.metadataSection },
                React.createElement("h5", { className: this._classNames.metadataSectionTitle }, "Version"),
                React.createElement("div", { className: this._classNames.metadataSectionContent }, this.props.listing.version_name)));
        }
        return null;
    };
    Listing.prototype._renderMetadata = function () {
        return (React.createElement("div", { className: this._classNames.metadata },
            this._renderBanner(),
            this._renderActions(),
            this._renderRating(),
            this._renderVersion()));
    };
    Listing.prototype._renderTitle = function () {
        return (React.createElement("div", { className: this._classNames.title }, this.props.listing.title));
    };
    Listing.prototype._renderDetailTabs = function () {
        return (React.createElement("div", { className: this._classNames.detailTabs },
            React.createElement(Pivot_1.Pivot, null,
                React.createElement(Pivot_1.PivotItem, { linkText: "Overview" },
                    React.createElement("div", { className: this._classNames.shortDescription }, this.props.listing.description_short),
                    React.createElement("div", { className: this._classNames.description }, this.props.listing.description)),
                React.createElement(Pivot_1.PivotItem, { linkText: "Reviews" },
                    React.createElement(ListingReviews, __assign({}, this.props))),
                React.createElement(Pivot_1.PivotItem, { linkText: "Activity" },
                    React.createElement(ListingActivity, __assign({}, this.props))),
                React.createElement(Pivot_1.PivotItem, { linkText: "Links" },
                    React.createElement(ListingLinks_1.ListingLinks, __assign({}, this.props))))));
    };
    Listing.prototype._renderDetail = function () {
        return (React.createElement("div", { className: this._classNames.detailContent },
            this._renderTitle(),
            this._renderDetailTabs()));
    };
    Listing.prototype._renderContent = function () {
        return (React.createElement("div", { className: this._classNames.content },
            this._renderMetadata(),
            this._renderDetail()));
    };
    Listing.prototype.render = function () {
        this._classNames = Listing_classNames_1.getClassNames(Listing_styles_1.getStyles(undefined, this.props.styles), this.props.className);
        return (React.createElement("div", { className: this._classNames.root },
            React.createElement(SyncOverlay_1.SyncOverlay, { sync: this.props.listing.saveSync, syncLabel: "Please wait..." }),
            React.createElement("div", { className: this._classNames.appDetails }, this._renderContent())));
    };
    Listing = __decorate([
        mobx_react_1.observer
    ], Listing);
    return Listing;
}(React.Component));
exports.Listing = Listing;
var ListingTitleContainer = /** @class */ (function (_super) {
    __extends(ListingTitleContainer, _super);
    function ListingTitleContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return "" + (_this.props.listingSupplier.value ? _this.props.listingSupplier.value.title : "");
        };
        _this._onRenderSync = function () {
            return "Loading...";
        };
        return _this;
    }
    ListingTitleContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.listingSupplier.sync, onRenderSync: this._onRenderSync, onRenderDone: this._onRenderDone });
    };
    return ListingTitleContainer;
}(React.Component));
exports.ListingTitleContainer = ListingTitleContainer;
var ListingContainer = /** @class */ (function (_super) {
    __extends(ListingContainer, _super);
    function ListingContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderListing = function (listing) {
            return React.createElement(Listing, { key: "listing-details", listing: listing, onEdit: _this.props.onEdit, onDelete: _this.props.onDelete, onOpen: _this.props.onOpen, onLoad: _this.props.onLoad });
        };
        return _this;
    }
    ListingContainer.prototype.render = function () {
        return React.createElement(ListingSupplier_1.ListingSupplierContainer, { listingSupplier: this.props.listingSupplier, onRenderListing: this._onRenderListing });
    };
    return ListingContainer;
}(React.Component));
exports.ListingContainer = ListingContainer;
var ListingDeleteDialog = /** @class */ (function (_super) {
    __extends(ListingDeleteDialog, _super);
    function ListingDeleteDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onDismiss = function () {
            _this.props.listingSupplier.clearValue();
        };
        _this._onClickCancel = function () {
            _this.props.listingSupplier.clearValue();
        };
        _this._onClickConfirm = function () {
            _this.props.listingSupplier.value.delete();
            _this.props.listingSupplier.clearValue();
        };
        return _this;
    }
    ListingDeleteDialog.prototype.render = function () {
        var listing = this.props.listingSupplier.value;
        var content = listing ? React.createElement("div", null,
            "Are you sure you want to delete ",
            React.createElement("strong", null, listing.title)) : undefined;
        return (React.createElement(Dialog_1.Dialog, { hidden: listing ? false : true, title: "Delete Listing", onDismiss: this._onDismiss },
            content,
            React.createElement(Dialog_1.DialogFooter, null,
                React.createElement(Button_1.DefaultButton, { onClick: this._onClickCancel }, "Cancel"),
                React.createElement(Button_1.PrimaryButton, { onClick: this._onClickConfirm }, "OK"))));
    };
    ListingDeleteDialog = __decorate([
        mobx_react_1.observer
    ], ListingDeleteDialog);
    return ListingDeleteDialog;
}(React.Component));
exports.ListingDeleteDialog = ListingDeleteDialog;
